import { combineReducers } from "redux";

import { auth } from "./auth.reducer";
import { reg } from "./reg.reducer";
import { alert } from "./alert.reducer";
import { slots } from "./slots.reducer";
import { session } from "./session.reducer";
import { sessionHistory } from "./sessionHistory.reducer";
import { appointments } from "./appointment.reducer";
import { counsellorStatus } from "./counsellor.reducer";
import { ForgotPassword } from "./forgotPassword.reducer";
import { note } from "./note.reducer";
import { whitelabel } from "./whitelabel.reducer";
import { faqs } from './faqs.reducer';
import { contactUs } from './contactUs.reducer';
import { sessionStatus } from './sessionStatus.reducer';
import { sessionHistoryStatus } from "./sessionHistoryStatus.reducer";
import { natureIssue } from "./natureIssue.reducer";
import { natureIssueUpdate } from "./natureIssueUpdate.reducer"
import { sessionCSVHistory } from './sessionCSVHistory.reducer'
import { serviceTypes } from "./serviceType.reducer";
import { familyMember, familyMembers } from "./familyMember.reducer";

const rootReducer = combineReducers({
  auth,
  reg,
  alert,
  slots,
  appointments,
  counsellorStatus,
  session,
  sessionHistory,
  ForgotPassword,
  note,
  whitelabel,
  faqs,
  contactUs,
  sessionStatus,
  sessionHistoryStatus,
  natureIssue,
  natureIssueUpdate,
  sessionCSVHistory,
  serviceTypes,
  familyMembers
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js